import React from 'react';
import PropTypes from 'prop-types';
// Models
import mSimcard from 'models/simcard';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { yesNoAsInvertedList, toBooleanOrNull, toIntegerOrNull } from 'utils/Tools';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';
import DeviceAutoCompleteFilter from 'devices/assets/main/DeviceAutoCompleteFilter';
import GroupSelectFieldFilter from 'simcards/assets/groups/GroupSelectFieldFilter';

const SimcardFilters = ({
  disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    iccid, number, status, groupId, available, device,
  } = filters;

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0 pb-3">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {isFieldDisplayable('iccid') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.iccid"
              value={iccid.value}
              onChange={(value) => onFilterFieldChange('iccid', value)}
            />
          </div>
        )}
        {isFieldDisplayable('number') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.number"
              value={number.value}
              onChange={(value) => onFilterFieldChange('number', value)}
            />
          </div>
        )}
        {isFieldDisplayable('status') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.status"
              value={status.value}
              items={mSimcard.statusList}
              onChange={(value) => onFilterFieldChange('status', value)}
            />
          </div>
        )}
        {isFieldDisplayable('groupId') && (
          <div className="col-12 col-md-4 col-xl-3">
            <GroupSelectFieldFilter
              groupId={toIntegerOrNull(groupId.value)}
              onChange={(value) => onFilterFieldChange('groupId', value)}
            />
          </div>
        )}
        {isFieldDisplayable('available') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.deviceAttached"
              value={toBooleanOrNull(available.value)}
              items={yesNoAsInvertedList}
              onChange={(value) => onFilterFieldChange('available', value)}
            />
          </div>
        )}
        {isFieldDisplayable('device') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DeviceAutoCompleteFilter
              device={device.value}
              onSelect={(value) => onFilterFieldChange('device', value)}
            />
          </div>
        )}
      </div>
    </FiltersTemplate>
  );
};

SimcardFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    iccid: listFilterShape,
    number: listFilterShape,
    status: listFilterShape,
    groupId: listFilterShape,
    available: listFilterShape,
    device: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mSimcard.listFeatures.searchFields)(SimcardFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/main/SimcardFilters.js